import { render, staticRenderFns } from "./TabEncomienda.vue?vue&type=template&id=4b890097&scoped=true&"
import script from "./TabEncomienda.vue?vue&type=script&lang=ts&"
export * from "./TabEncomienda.vue?vue&type=script&lang=ts&"
import style0 from "./TabEncomienda.vue?vue&type=style&index=0&id=4b890097&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b890097",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4b890097', component.options)
    } else {
      api.reload('4b890097', component.options)
    }
    module.hot.accept("./TabEncomienda.vue?vue&type=template&id=4b890097&scoped=true&", function () {
      api.rerender('4b890097', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/tabs/TabEncomienda.vue"
export default component.exports